import {DateTime} from 'luxon';

export const formatDate = (
    dateFormatIso?: string | null,
    format: Intl.DateTimeFormatOptions = DateTime.DATE_SHORT
): string => {
    if (dateFormatIso === null || dateFormatIso === undefined) {
        return '';
    }
    const dateTime = getDateTime(dateFormatIso);
    if (!dateTime.isValid) {
        return '';
    }
    return dateTime.setLocale('fr').toLocaleString(format);
};

export const getDateTime = (dateFormatIso: string): DateTime => {
    return DateTime.fromISO(dateFormatIso.replace(' ', 'T')); //@todo virer le replace quand le back renvera toujours de l'iso 8601
};

/** Calcul le nombre de jour de différence entre 2 dates */
export const dayDiff = (date: DateTime, dateComp: DateTime): number => {
    const late = date.startOf('day').diff(dateComp.startOf('day'), 'days');
    const {days} = late.toObject();
    return days ?? 0;
};

export const durationSince = (isoDate: string) => {
    const date = DateTime.fromISO(isoDate);
    if (!date.isValid) {
        return null;
    }
    const now = DateTime.now();
    return date.setLocale('fr').toRelative({base: now});
};
